const counterEmailList = [
    {
        value: 0,
        title: "All"
    },
    {
        value: 1,
        title: "No"
    },
    {
        value: 2,
        title: "Yes"
    },
];

export default counterEmailList;
